import { useCallback, useState } from "react";

export type DirectionValues = ["desc", "asc", null];
export type Direction = DirectionValues[number];

export interface IActiveSorting {
  orderBy: string;
  direction: Direction;
}

const defaultSorting: IActiveSorting = {
  orderBy: "created",
  direction: "desc",
};

export const useSortableTable = () => {
  const [activeSorting, setActiveSorting] =
    useState<IActiveSorting>(defaultSorting);
  const onSort = useCallback(
    (orderBy: string, direction: Direction) => {
      if (!direction) {
        setActiveSorting(defaultSorting);
        return;
      }
      setActiveSorting({
        orderBy,
        direction,
      });
    },
    [setActiveSorting],
  );

  return { activeSorting, setActiveSorting: onSort };
};
